import React from 'react';
import ContactForm from '../components/ContactForm';
import './../styles/landing.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <h1>Contact Us</h1>
      <div className="contact-container">
        <div className="contact-info animate-fade-up">
          <h2>Our Office</h2>
          <p>
            Thank you for making time to contact Record News.
            Please note, we cannot respond to questions about general information or questions regarding current coverage we provide a service for media monitoring companies.
          </p>
          <address>
            152 Van Dalen South<br />
            Willowbrook<br />
            Roodepoort<br />
            1724<br />
            South Africa
          </address>
        </div>
        <div className="contact-form animate-fade-up">
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;
